/**
 * @desc 物流报价方案主体更新
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(
  body: defs.tms.LogisticsQuotationUpdateDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/tms/logisticsQuotation/quotation/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
